import React from 'react';

import { Row, Form, Spinner } from 'react-bootstrap';
import Select from 'react-select';

import { customStyles } from '../utils';

import './styles.scoped.css';

// @Exception values map to the ProScore proc (A = all checks, N = on-time only, Y = late only).
export const exceptionOptions = [
  { label: 'A - All Checks', value: 'A' },
  { label: 'N - On-time Only', value: 'N' },
  { label: 'Y - Late Only', value: 'Y' },
];

export const PrevailingWageForm = ({ form, setForm, handleChange, isLoadingClients, clientOptions }) => (
  <div className="filters-container">
    <div className="filter-row" style={{ marginTop: '30px' }}>
      <Form.Group as={Row} controlId="PeriodEndDate" style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '160px' }}>
          <div className="required">Period End Date</div>
        </Form.Label>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="date"
          name="PeriodEndDate"
          value={form?.PeriodEndDate}
          onChange={handleChange}
        />
      </Form.Group>
    </div>

    <div className="filter-row">
      <Form.Group as={Row} style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '160px' }}>
          <div className="required">Client Name</div>
        </Form.Label>
        <Select
          isMulti
          closeMenuOnSelect={false}
          isDisabled={isLoadingClients}
          menuPlacement="auto"
          menuPortalTarget={typeof document === 'undefined' ? null : document.body}
          styles={{
            ...customStyles('365px'),
            menuList: base => ({ ...base, maxHeight: 260 }),
            menuPortal: base => ({ ...base, zIndex: 9999 }),
          }}
          options={clientOptions}
          value={clientOptions.filter(option =>
            (form?.ClientName ? form.ClientName.split(',') : []).includes(option.value),
          )}
          onChange={selectedOptions =>
            setForm({ ...form, ClientName: (selectedOptions || []).map(option => option.value).join(',') })
          }
          placeholder="Multi-Select"
        />
        {isLoadingClients && (
          <Spinner as="span" animation="border" size="sm" aria-hidden="true" className="dropdown-spinner" />
        )}
      </Form.Group>
    </div>

    <div className="filter-row">
      <Form.Group as={Row} controlId="CutOffDate" style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '160px' }}>Cut Off Date</Form.Label>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="date"
          name="CutOffDate"
          value={form?.CutOffDate}
          onChange={handleChange}
        />
      </Form.Group>
    </div>

    <div className="filter-row">
      <Form.Group as={Row} style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '160px' }}>Exception Type</Form.Label>
        <Select
          menuPlacement="auto"
          menuPortalTarget={typeof document === 'undefined' ? null : document.body}
          styles={{
            ...customStyles('365px'),
            menuPortal: base => ({ ...base, zIndex: 9999 }),
          }}
          options={exceptionOptions}
          value={exceptionOptions.find(option => option.value === form?.Exception) || null}
          onChange={selectedOption => setForm({ ...form, Exception: selectedOption?.value || 'A' })}
        />
      </Form.Group>
    </div>
  </div>
);
